import React, { useRef } from "react"
import { Container, withFilters } from "@inlet/react-pixi"
import { DropShadowFilter } from "@pixi/filter-drop-shadow"

const Shadow = withFilters(Container, { shadow: DropShadowFilter })

export default Shadow
